import React, { Component } from 'react'
import Titulo from "../../generico/TituloPagina";

export default class FlyerEmpresa extends Component {

    constructor(props) {
        super(props);
        this.text = "";
        this.state = {
            textFlyer: {}
        }
    }

    componentDidMount() {
        let json = sessionStorage.getItem("textFlyer");
        this.setState({ textFlyer: JSON.parse(json) });
    }

    imageOnError = (e) => {
        e.target.src = "./dist/img/logo_default.png";
    }

    render() {

        let { descripcion, vigencia, nombreEmpresa, imagenFlyer, logoEmpresa, direccion } = this.state.textFlyer;

        logoEmpresa = logoEmpresa ? logoEmpresa : "./dist/img/logo_default.png";
        imagenFlyer = imagenFlyer ? imagenFlyer : "./dist/img/logo_default.png";

        return (
            <div className="content-wrapper">
                <Titulo texto="Convenios" />
                <section className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-flyer">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4 text-flyer">
                                                <img src={logoEmpresa} className="m-auto w-75 p-4" alt={nombreEmpresa} onError={(e) => this.imageOnError(e)} />
                                                <p className='card-title'>Descripción</p>
                                                <p className="card-text">{descripcion}</p>
                                                <p className='card-title'>Vigencia</p>
                                                <p className="card-text">{vigencia}</p>
                                                <p className='card-title'>Dirección</p>
                                                <p className="card-text">{direccion}</p>
                                            </div>
                                            <div className="col-md-8">
                                                <img className="img-flyer" src={imagenFlyer} onError={(e) => this.imageOnError(e)} alt={`Flyer - ${nombreEmpresa}`} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

}